import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu } from "../../../../api";
import { menuFallback } from "../../../../utils/menuFallback";

const menuController = new Menu();

export function NavMobile({ navMobile, setNavMobile }) {
  const [menuData, setMenuData] = useState([]);
  const [activeItem, setActiveItem] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  const handleVerVacantes = () => {
    setNavMobile(false);
    navigate("/recursohumano");
    setTimeout(() => {
      const el = document.getElementById("vacantes");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 150);
  };

  useEffect(() => {
    setActiveItem(location.pathname);
  }, [location]);

  useEffect(() => {
    (async () => {
      try {
        const response = await menuController.getMenu(true);
        setMenuData(response);
      } catch {
        setMenuData(menuFallback);
      }
    })();
  }, []);

  return (
    <div className="px-4 py-5">
      <ul className="flex flex-col gap-1">
        {menuData.map((item, index) => {
          const isActive = activeItem === item.url;
          return (
            <li
              key={item.id || item.url}
              className="animate-fade-in"
              style={{ animationDelay: `${index * 40}ms` }}
            >
              <Link
                className={`
                  flex items-center gap-3 py-3 px-4 text-base font-semibold rounded-xl transition-all duration-200
                  ${isActive
                    ? "bg-[#C81416] text-white shadow-[0_4px_14px_rgba(200,20,22,0.35)]"
                    : "text-white/80 hover:bg-white/10 hover:text-white"
                  }
                `}
                to={item.url}
                onClick={() => setNavMobile(false)}
              >
                {isActive && <span className="w-1.5 h-1.5 rounded-full bg-white flex-shrink-0" />}
                {item.title}
              </Link>
            </li>
          );
        })}
      </ul>
      <div className="mt-5 pt-5 border-t border-white/10 flex flex-col gap-3">
        <button
          type="button"
          onClick={handleVerVacantes}
          className="flex items-center justify-center gap-2 w-full py-2.5 border border-white/20 text-white/80 font-semibold rounded-xl transition-all duration-200 hover:bg-white/10 text-sm"
        >
          Ver Vacantes Disponibles
        </button>
        <Link
          to="/recursohumano/formulario"
          onClick={() => setNavMobile(false)}
          className="flex items-center justify-center gap-2 w-full py-3 bg-[#C81416] hover:bg-[#8c0e0f] text-white font-bold rounded-xl transition-all duration-300"
        >
          Únete al Equipo
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M17 8l4 4m0 0l-4 4m4-4H3" />
          </svg>
        </Link>
      </div>
    </div>
  );
}
